import styled from 'styled-components';

import { flexStyles } from '../../../common/flexStyles';

export const StyledServiceProvidingLocationUsingOwnDataUpdateFormPart = styled.div`
   ${flexStyles.layout(
      '12px',
      flexStyles.whole(), // name
      flexStyles.half(), // city,
      flexStyles.half('113px'), // postcode
      flexStyles.half(), // street
      flexStyles.quarter('8em'), // house
      flexStyles.quarter('8em'), // flat
      flexStyles.half('16em'), // phone
      flexStyles.half() // email
   )}
`;

StyledServiceProvidingLocationUsingOwnDataUpdateFormPart.displayName =
   'StyledServiceProvidingLocationUsingOwnDataUpdateFormPart';
